import { GET_FREEPIK_IMAGES } from '../constants';

export const getFreepikImages = async (query, page = 1) => {
  if (!GET_FREEPIK_IMAGES) {
    console.warn(
      'Freepik endpoint (REACT_APP_GET_FREEPIK_IMAGES) is not configured.'
    );
    return [];
  }

  try {
    if (query !== '') {
      const url = `${GET_FREEPIK_IMAGES}?query=${encodeURIComponent(
        query
      )}&page=${page}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data.data;
    }
    return [];
  } catch (err) {
    console.error('Error fetching Freepik images:', err);
    throw new Error(err.message);
  }
};

export default getFreepikImages;
